// Queries, query options, and key factory
export {
  useShelves,
  useShelf,
  useShelfStats,
  useShelfContainers,
  prefetchShelves,
  shelfKeys,
  shelfQueries
} from './services/shelves.queries';

// Mutations
export {
  useCreateShelf,
  useUpdateShelf,
  useDeleteShelf
} from './services/shelves.mutations';

// API
export { shelvesApi } from './services/shelves.api';

// Components
export { ShelvesPageContent } from './components/shelves-page-content';
export { ShelvesListing } from './components/shelves-listing';
export { ShelvesStatCards } from './components/shelves-stat-cards';
export { ShelfAddDialog } from './components/shelf-add-dialog';
export { ShelfEditDialog } from './components/shelf-edit-dialog';
export { ShelvesTableActionBar } from './components/shelves-table-action-bar';

// Types
export type {
  Shelf,
  ShelfStats,
  ShelvesListParams,
  CreateShelfRequest,
  UpdateShelfRequest,
  ShelfContainerAssignment,
  ShelfContainersListParams
} from './types';
